// Account Receivable Actions

import Axios from 'axios'
import * as helpers from '@/mixins/helperFunctions.js'

// ***** Get accountReceivableList from backend then update accountReceivableList in vuex store ***** //
export const updateAccountReceivableList = async ({ commit }, payload = null) => {
  let params = {}

  if (payload) {
    params = {
      search: payload.search,
      page: payload.page,
      per_page: payload.rowsPerPage,
      column: payload.sortBy,
      sortDir: payload.descending ? 'desc' : 'asc'
    }
  }

  try {
    const result = await Axios.get('account_receivable_index', {
      params: params
    })
    commit('updateAccountReceivableList', result.data.data)
  } catch (error) {
    helpers.showErrorMessage(error, 'An error occurred, fetching information failed')
  }
}

// ***** Fetch accountReceivableInfo from backend ***** //
export const fetchAccountReceivableInfo = async ({ commit }, payload = null) => {
  if (!helpers.checkId(payload)) {
    throw new Error('Error')
  }

  try {
    const result = await Axios.get(`account_receivable_show/${payload}`)
    commit('updateAccountReceivableInfo', result.data.data)
  } catch (error) {
    helpers.showErrorMessage(error, 'An error occurred, fetching information failed')
  }
}

// ***** Fetch accountReceivableBalanceDetails from backend ***** //
export const fetchAccountReceivableBalanceDetails = async ({ commit }) => {
  try {
    const result = await Axios.get(`account_receivable_balance_details`)
    commit('updateAccountReceivableBalanceDetails', result.data.data)
  } catch (error) {
    helpers.showErrorMessage(error, 'An error occurred, fetching information failed')
  }
}
